// pd3.js - Patio Door Configuration 3
// Wrapper component that uses the PD template with specific configuration

import React from 'react';
import PD from './pd';
import { pageConfigs } from '../../configs';

const PD3 = () => {
  const controlMapSections = [
    // Add control map sections as they are created
  ];

  return (
    <PD
      config={pageConfigs.pd3}
      controlMapSections={controlMapSections}
      documentType="patiodoors"
      itemPath="patiodoors/pdt/pd3"
    />
  );
};

export default PD3;
